<template>
  <div>
    <b-modal ref="seeOrderDetail" title="Order Detail" :ok-only="true">
      <b-table-simple caption-top stacked>
        <b-tbody>
          <b-tr>
            <b-th> Order Information </b-th>
            <b-td stacked-heading="Order ID:">{{ detail.OrderCode }} </b-td>
            <b-td stacked-heading="Order Date:">{{ formatDate }} </b-td>
            <b-td stacked-heading="Quantity:"
              >{{ detail.TotalRecords | numberFormat("", 0) }}
            </b-td>
            <b-td stacked-heading="Total Charge:"
              >{{ detail.TotalCost | numberFormat() }}
            </b-td>
            <b-td stacked-heading="Type:">{{ detail.OrderType }} </b-td>
          </b-tr>
          <b-tr>
            <b-th>Selected Services:</b-th
            ><b-td>
              <div
                class="aggreement-content"
                v-html="ServicesListHtmlText"
                v-if="ServicesListHtmlText"
              ></div
            ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-modal>
    <b-row class="justify-content-md-center">
      <b-col xl="6" lg="6" md="6" sm="6" class="left-title"
        ><b-input-group class="mb-2">
          <b-input-group-prepend is-text>
            <icon name="search" />
          </b-input-group-prepend>
          <b-form-input
            class="search-text"
            v-model="searchKey"
            @input="searchChange"
            placeholder="Search for order ID, name to filter"
            aria-label="Text input with checkbox"
          ></b-form-input> </b-input-group
      ></b-col>
      <b-col xl="6" lg="6" md="6" sm="6" class="right-title">
        <b-form-select
          v-model="accountId"
          @change="leadPageChange"
          v-if="roleName === 'Reseller'"
          class="account-select"
        >
          <option value="0">ALL Accounts</option>
          <option v-for="item in accountList" :value="item.AccountId">
            {{ item.AccountDesc }}
          </option>
        </b-form-select>
        <b-link :href="exportExcel" target="blank" class="btn">Export All</b-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table striped hover :fields="leadsFields" :items="orderData">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(Account)="data">
            <span>{{
              roleName === "Power User"
                ? data.item.UserName
                : roleName === "Reseller"
                ? data.item.AccountName
                : ""
            }}</span>
          </template>
          <template #cell(Action)="data">
            <b-dropdown
              size="lg"
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template #button-content>
                <icon name="ellipsis-v" />
              </template>
              <b-dropdown-item href="#" @click="showDetail(data)"
                >View</b-dropdown-item
              >
              <b-dropdown-item
                :href="rootPath + '?id=' + data.item.OrderGuid + '&type=1'"
                v-if="
                  data.item.Status === 50 && data.item.IsExistFulfillmentFile
                "
                >Down Fulfillment File</b-dropdown-item
              >

              <b-dropdown-item
                :href="rootPath + '?id=' + data.item.OrderGuid + '&type=2'"
                v-if="data.item.Status === 50 && data.item.IsExistReportsFile"
                >Down Reports File</b-dropdown-item
              >
            </b-dropdown></template
          >
        </b-table>
        <b-row>
          <b-col md="3" lg="4" xl="4" sm="3" class="pageinfo">
            1-{{
              totalCount % pageSize === 0
                ? totalCount % pageSize
                : parseInt(totalCount / pageSize) + 1
            }}
            of
            {{ totalCount }}
          </b-col>
          <b-col>
            <b-pagination
              v-model="currentPage"
              page-class="page-class"
              :total-rows="totalCount"
              @change="leadPageChange"
              prev-text="＜PREVIOUS"
              next-text="NEXT＞"
              first-text="First"
              last-text="Last"
              align="left"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MMaOrderDetailModal from "@/components/orderHistory/MMaOrderDetailModal";
import utils from "@/assets/utils";

export default {
  components: {
    MMaOrderDetailModal,
  },
  props: {
    orderType: {
      type: Number,
    },
  },
  data() {
    return {
      accountId: "0",
      searchKey: "",
      leadsFields: [
        {
          label: "Date",
          key: "CreateTime",
          formatter: (value) => {
            return utils.dateFormat(value, "MM/DD/YYYY");
          },
        },
        { label: "Order ID", key: "OrderCode" },
        { label: "Order Name", key: "OrderDesc" },
        {
          label: "Status",
          key: "StatusDesc",
          formatter: (value) => {
            return value === "" ? "-" : value;
          },
        },
        { label: "Service", key: "OrderType" },
        {
          label: "Quantity",
          key: "TotalRecords",
          formatter: (value) => {
            return utils.numberFormat(value, "", 0);
          },
        },
        {
          label: "Price",
          key: "TotalCost",
          formatter: (value) => {
            return utils.numberFormat(value);
          },
        },
        { label: "Account", key: "Account" },
        { label: "Action", key: "Action" },
      ],
      orderData: [],
      totalCount: 0,
      pageSize: 18,
      currentPage: 1,
      isOrderBusy: true,
      detail: {},
      ServicesListHtmlText: "",
    };
  },
  computed: {
    rootPath() {
      return utils.getRootPath();
    },
    accountList() {
      return this.$store.getters["user/accountList"];
    },
    roleName() {
      return this.$store.state.site.User_RoleName;
    },
    formatDate() {
      if (this.detail.CreateTime) {
        return utils.dateFormat(this.detail.CreateTime);
      }
    },
    exportExcel() {
      return `${this.rootPath}RPT/DownReportFile.aspx?orderType=${this.orderType}&accountId=${this.accountId}&searchKey=${this.searchKey}`;
    },
  },
  created() {
    this.leadPageChange();
  },
  methods: {
    leadPageChange() {
      this.isOrderBusy = true;
      this.$http
        .post("rpt/MyOrdersHistory.aspx/GetMyAcxiomOrderMoreByOrder", {
          orderType: this.orderType,
          accountId: this.accountId,
          searchKey: this.searchKey,
          pagingOptions: {
            PageNumber: this.currentPage,
            PageSize: this.pageSize,
            Start: 0,
            SortBy: "OrderDate",
            SortDescending: true,
            FetchTotalRecordCount: true,
            TotalRecordCount: 0,
          },
        })
        .then(
          (resp) => {
            this.isOrderBusy = false;
            if (this.orderType === 0) {
              this.orderData = resp.body.d.DataSource.CleanListData.Items;
              this.totalCount =
                resp.body.d.DataSource.CleanListData.TotalRecordCount;
            } else if (this.orderType === 1) {
              this.orderData = resp.body.d.DataSource.EnhanceListData.Items;
              this.totalCount =
                resp.body.d.DataSource.EnhanceListData.TotalRecordCount;
            } else if (this.orderType === 2) {
              this.orderData =
                resp.body.d.DataSource.PortraitReportlistData.Items;
              this.totalCount =
                resp.body.d.DataSource.PortraitReportlistData.TotalRecordCount;
            } else if (this.orderType === 3) {
              this.orderData = resp.body.d.DataSource.EmailAppendData.Items;
              this.totalCount =
                resp.body.d.DataSource.EmailAppendData.TotalRecordCount;
            } else if (this.orderType === 5) {
              this.orderData = resp.body.d.DataSource.PhoneAppendData.Items;
              this.totalCount =
                resp.body.d.DataSource.PhoneAppendData.TotalRecordCount;
            } else if (this.orderType === 6) {
              this.orderData = resp.body.d.DataSource.PhoneVerification.Items;
              this.totalCount =
                resp.body.d.DataSource.PhoneVerification.TotalRecordCount;
            } else if (this.orderType === 8) {
              this.orderData = resp.body.d.DataSource.ReverseEmailData.Items;
              this.totalCount =
                resp.body.d.DataSource.ReverseEmailData.TotalRecordCount;
            }
          },
          (resp) => {}
        );
    },
    searchChange() {
      if (this.searchKey.length >= 3 || this.searchKey === "") {
        this.leadPageChange();
      }
    },
    showDetail(data) {
      this.$http
        .post("dialogs/MyAcxiomOrderDetails.aspx/GetOrder", {
          orderId: data.item.OrderId,
        })
        .then(
          (resp) => {
            this.isOrderBusy = false;
            this.detail = resp.body.d.DataSource.Order;
            this.detail.OrderType = data.item.OrderType;
            this.ServicesListHtmlText =
              resp.body.d.DataSource.ServicesListHtmlText;
            this.$refs.seeOrderDetail.show();
          },
          (resp) => {}
        );
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  text-align: center;
  font-weight: bold;
  color: black;
}
.content {
  display: flex;
  justify-content: center;
  background: white;
}
.reach {
  width: 90%;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
}
.left-title {
  text-align: left;
}
.right-title {
  text-align: right;
}

.search-text {
  max-width: 500px;
}
.account-select {
  max-width: 200px;
}
.text-danger {
  color: $color-primary !important;
}
.page-class.page-link {
  color: $color-primary !important;
}
.pageinfo {
  font-size: 1.1rem;
  font-weight: bold;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/orderHistory/MMaOrderHistory.vue